import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import account from './account'
import permissions from './permissions'

import companies from './companies'
import farms from './farms'
import employees from './employees'
import stocks from './stocks'
import deliveries from './deliveries'
import ingredients from './ingredients'
import animalfeed from './animalfeed'
import animaltypes from './animaltypes'
import recipes from './recipes'
import fooder from './fooder'
import mixers from './mixers'
import rations from './rations'
import additional from './additional'
import history from './history'
import groups from './groups'
import reports from './reports'
import dashboard from './dashboard'
import schedule from './schedule'
import kkzreports from './reports/kkzreports'
import ingredienttypes from './ingredienttypes'
import planning from './planning'
import baseMixers from './baseMixers'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,

  modules: {
    app,
    account,
    permissions,
    deliveries,
    ingredients,
    ingredienttypes,
    animalfeed,
    animaltypes,
    recipes,
    farms,
    fooder,
    mixers,
    rations,
    additional,
    employees,
    history,
    groups,
    reports,
    dashboard,
    schedule,
    kkzreports,
    companies,
    stocks,
    planning,
    baseMixers
  },

  state: {
    clientId: null,
    client: null,
    reportFilters: null,
    reportFiltersRaw: null,
    updaters: {
      periods: null,
      planning: null
    }
  },

  getters: {
    clientId (state) {
      return state.clientId
    },

    client (state) {
      return state.client
    },

    reportFilters (state) {
      return state.reportFilters
    },

    reportFiltersRaw (state) {
      return state.reportFiltersRaw
    }
  },

  mutations: {
    setClientId (state, value) {
      state.clientId = value
    },

    setReportFilters (state, value) {
      state.reportFilters = value
    },

    setReportFiltersRaw (state, value) {
      state.reportFiltersRaw = value
    },

    setPeriodsUpdater (state, value) {
      state.updaters.periods = value
    },

    setPlanningUpdater (state, value) {
      state.updaters.planning = value
    }
  },

  actions: {
    setClientId ({ commit }, value) {
      commit('setClientId', value)
    },

    setReportFilters ({ commit }, value) {
      commit('setReportFilters', value)
    },

    setReportFiltersRaw ({ commit }, value) {
      commit('setReportFiltersRaw', value)
    },

    setPeriodsUpdater ({ commit }, value) {
      commit('setPeriodsUpdater', value)
    },

    updatePeriods ({ state }) {
      if (state.updaters.periods) {
        state.updaters.periods()
      }
    },

    setPlanningUpdater ({ commit }, value) {
      commit('setPlanningUpdater', value)
    },

    updatePlanning ({ state }) {
      if (state.updaters.planning) {
        state.updaters.planning()
      }
    },

    allowAllPermissions ({ state }) {
      for (let section in state.perm) {
        for (let perm in state.perm[section]) {
          state.perm[section][perm].view = true
          state.perm[section][perm].add = true
          state.perm[section][perm].change = true
          state.perm[section][perm].delete = true
        }
      }
    }
  }
})

export default store
